var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { VButtonSizes, VerdantVariants } from "../../../types/theme";
import { ButtonSizes, IconButtonSizes, TagClickableSizes, TextButtonSizes, } from "./sizes";
import { ButtonVariants, TagClickableVariants } from "./variants";
import { cgx } from "@springcare/dsm";
export var buttonTheme = {
    baseStyle: __assign(__assign({}, cgx.textStyles["body-medium-strong"]), { borderWidth: "v-width-thin", borderColor: "transparent", _focus: {
            boxShadow: "none",
        }, _focusVisible: {
            boxShadow: "outline",
        } }),
    sizes: __assign(__assign(__assign(__assign({}, ButtonSizes), IconButtonSizes), TagClickableSizes), TextButtonSizes),
    variants: __assign(__assign({}, ButtonVariants), TagClickableVariants),
    defaultProps: {
        variant: VerdantVariants.highEmphasis,
        size: VButtonSizes.md,
    },
};
